import { shortcutLabel } from '@/lib/platform/platform';

/**
 * Keyboard shortcut hint strings for canvas actions.
 * Returns the platform-appropriate label (⌘ on Mac, Ctrl on Windows/Linux),
 * or an empty string on touch-only devices.
 */
export const canvasShortcuts = {
  copy:          () => shortcutLabel('⌘C',   'Ctrl+C'),
  duplicate:     () => shortcutLabel('⌘D',   'Ctrl+D'),
  delete:        () => shortcutLabel('⌫',    '⌫'),
  lock:          () => shortcutLabel('⌘⇧L',  'Ctrl+Shift+L'),
  unlock:        () => shortcutLabel('⌘⇧L',  'Ctrl+Shift+L'),
  bringToFront:  () => shortcutLabel('⌘⇧]',  'Ctrl+Shift+]'),
  bringForward:  () => shortcutLabel('⌘]',   'Ctrl+]'),
  sendBackward:  () => shortcutLabel('⌘[',   'Ctrl+['),
  sendToBack:    () => shortcutLabel('⌘⇧[',  'Ctrl+Shift+['),
  selectAll:     () => shortcutLabel('⌘A',   'Ctrl+A'),
  paste:         () => shortcutLabel('⌘V',   'Ctrl+V'),
  zoomIn:        () => shortcutLabel('⌘+',   'Ctrl++'),
  zoomOut:       () => shortcutLabel('⌘−',   'Ctrl+−'),
  zoom100:       () => shortcutLabel('⌘1',   'Ctrl+1'),
  fitView:       () => shortcutLabel('⌘0',   'Ctrl+0'),
  toolSelect:    () => shortcutLabel('V',     'V'),
  toolHand:      () => shortcutLabel('H',     'H'),
  toolDraw:      () => shortcutLabel('D',     'D'),
  toolSticky:    () => shortcutLabel('S',     'S'),
  toolShape:     () => shortcutLabel('R',     'R'),
  toolText:      () => shortcutLabel('T',     'T'),
  toolFrame:     () => shortcutLabel('F',     'F'),
  toolConnector: () => shortcutLabel('L',     'L'),
  toolEmoji:     () => shortcutLabel('E',     'E'),
} as const;
